import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import { QuantiteDossierByPeriodeDTO } from "src/app/new-dashboard/core/model/quantite-dossier-by-periode-dto";
import { DashboardPpService } from "src/app/new-dashboard/core/service/dashboard-pp.service";
import * as Highcharts from "highcharts";
import { ChartViewDTO } from "src/app/new-dashboard/core/model/chart_view/chart-view-dto";
import { DashboardAllMarcheService } from "src/app/new-dashboard/core/service/dashboard-all-marche.service";
import { QuantiteDossierPortefeuilleParProduitDTO } from "src/app/new-dashboard/core/model/quantite-dossier-portefeuille-par-produit-dto";

@Component({
  selector: "app-pp-production",
  templateUrl: "./pp-production.component.html",
  styleUrls: ["./pp-production.component.scss"],
})
export class PpProductionComponent implements OnInit {
  highcharts = Highcharts;
  chartOptionsQuantiteByPeriode: any;
  chartOptionsMontantByPeriode: any;

  quantiteByPeriode: ChartViewDTO;
  montantByPeriode: ChartViewDTO;

  quantiteDossierByPeriodeDTO: QuantiteDossierByPeriodeDTO;

  quantiteDossierPortefeuilleParProduitDTOs: QuantiteDossierPortefeuilleParProduitDTO[];

  constructor(
    private _dashboardPpService: DashboardPpService,
    private _dashboardAllMarcheService: DashboardAllMarcheService
  ) {}

  ngOnInit() {
    this.quantiteDossierByPeriode();
    this.quantiteDossierStatutSurLes6DerniersMois();
    this.montantDossierStatutSurLes6DerniersMois();
    this.quantiteDossierPortefeuilleParProduit("_");
  }

  quantiteDossierByPeriode() {
    this._dashboardPpService.QuantiteDossierByPeriode().subscribe(
      (data) => {
        this.quantiteDossierByPeriodeDTO = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  quantiteDossierStatutSurLes6DerniersMois() {
    this._dashboardPpService
      .quantiteDossierStatutSurLes6DerniersMois()
      .pipe(first())
      .subscribe(
        (response) => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Quantité de dossier sur les 6 derniers mois",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories,
            },
            yAxis: {
              title: {
                text: "Qté",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.quantiteByPeriode.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  montantDossierStatutSurLes6DerniersMois() {
    this._dashboardPpService
      .montantDossierStatutSurLes6DerniersMois()
      .pipe(first())
      .subscribe(
        (response) => {
          this.montantByPeriode = response;

          this.chartOptionsMontantByPeriode = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Montant de dossier sur les 6 derniers mois",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.montantByPeriode.categories,
            },
            yAxis: {
              title: {
                text: "Qté",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.montantByPeriode.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleParProduit(codeAgence) {
    this._dashboardAllMarcheService
      .quantiteDossierPortefeuilleParProduit("PRODUCT_PROGRAM", codeAgence)
      .pipe(first())
      .subscribe(
        (response) => {
          this.quantiteDossierPortefeuilleParProduitDTOs = response;
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
